<template>
  <div class="formdata building">
    <div class="header-container">
    <h3 id="planned_replacement_question">Wann möchten Sie mit dem Einbau der PV-Anlage beginnen?</h3>
</div>
    <CustomRadioGroup
        :options="plannedReplacements"
        v-model="selectedAnswer"
        aria-labelledby="planned_replacement_question"
        @optionSelected="submit"
    >
      <template #option="{ option }">
        <label :for="'planned_replacement_' + option.value">
          <img :src="option.image" alt="" aria-hidden="true" />
          <p>{{ option.name }}</p>
        </label>
      </template>
    </CustomRadioGroup>

    <button class="button button_yellow right" v-if="selectedAnswer" @click="submit">Weiter</button>
  </div>
</template>

<script setup>
import {computed} from 'vue';
import {useWorkflowStore} from '@/stores/workflow';
import {plannedReplacements, plannedReplacementApi} from "@/data/plannedReplacementData";
import CustomRadioGroup from "@/components/CustomRadioGroup.vue";

const workflowStore = useWorkflowStore();

const getPlannedReplacementEventData = (selectedValue) => {
  const fullAnswer = plannedReplacements.find(bt => bt.value === selectedValue);

  if (fullAnswer) {
    return {
      value: selectedValue,
      apiDefinition: plannedReplacementApi,
      apiValue: fullAnswer.api,
      available: fullAnswer.available
    };
  }
  return null;
};


const selectedAnswer = computed({
  get() {
    return workflowStore.workflowContext.formData.building?.planned_replacement || null;

  },
  set(newValue) {
    // Der Setter wird aufgerufen, sobald der Benutzer einen Radio-Button auswählt.
    // Hier senden wir ein Event, das den Wert sofort im Store aktualisiert.
    const eventData = getPlannedReplacementEventData(newValue);
    workflowStore.sendWorkflowEvent({
      type: 'UPDATE_SELECTED_PLANNED_REPLACEMENT_ANSWER',
      data: eventData,
    });
  }
});



const submit = () => {
  // Diese Funktion wird nur aufgerufen, wenn der "Weiter"-Button geklickt wird.
  // Der Wert ist bereits durch den Setter des computed properties im Store gespeichert.
  if (selectedAnswer.value) {
    const eventData = getPlannedReplacementEventData(selectedAnswer.value);
    workflowStore.sendWorkflowEvent({
      type: 'NEXT',
      data: eventData,
    });
  }
};


</script>

<style scoped>



</style>